import { Location } from "@angular/common";
import { inject } from "@angular/core";
import { CanActivateFn, NavigationExtras, Router, UrlTree } from "@angular/router";
import { map, Observable } from "rxjs";

import { AuthFacade } from "state/auth.facade";

export const AuthGuard: CanActivateFn = (): Observable<true | UrlTree> => {
  const authFacade = inject(AuthFacade);
  const router = inject(Router);
  const location = inject(Location);

  return authFacade.user$.pipe(
    map((user) => {
      if (user) {
        return true;
      }

      const navigationOptions: NavigationExtras = {};

      const destinationPath = location.path();
      if (destinationPath) {
        navigationOptions.queryParams = { destinationPath };
      }

      return router.createUrlTree(["login"], navigationOptions);
    })
  );
};
